export default {
  sessionCheckInterval: 300000,  // ms = 5 minutes
  // sessionCheckInterval: 10000,   // debug
};
